import { Card } from "antd";
import React, { useEffect, useRef } from "react";
import { useDrop } from "react-dnd";


export default function PublisherCard({ id, onDrop, imprint = "", drop_type = "", className = "", dragging = false, setDragging = () => { }, children }) {


  const imprintRef = useRef(imprint);

  useEffect(() => {

    imprintRef.current = imprint;

  }, [imprint])

  const [{ isOver }, dropRef] = useDrop(() => ({
    accept: drop_type,
    drop: (item) => {
      onDrop(item, id, imprintRef.current)
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  let _cls = className;

 

  if (id === "raw" && dragging === "raw") {
      if(isOver){
          _cls += " removingOver";
    } else {
          _cls += " removing";
    }

  }

  if (id === "publisher" && dragging === "publisher") {

    if(isOver){
          _cls += " droppingOver";
    } else {
          _cls += " dropping";
    }

  }

  

  return (
    <div ref={(node) => dropRef(node)}>

      <Card  bodyStyle={{ "padding": "5px 10px" }} className={_cls}
      // style={{ backgroundColor: (isOver || dragging) ? "#e6f7ff" : "#fbfbfb" }}
      >
        
        {children}
      </Card>
    </div>
  );
}
